module.exports = __webpack_public_path__ + "static/img/fav.003c64c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fav.png
// module id = 1358
// module chunks = 1